import { defineMessages } from 'react-intl-next';
export default defineMessages({
  logoAltText: {
    id: 'fabric.editor.ai.components.atlassianIntelligenceLogo.logoAltText',
    defaultMessage: 'Atlassian Intelligence Logo',
    description: 'Atlassian Intelligence logo alt text'
  }
});